"use client";
import React, { useState } from "react";
import { Grid } from "../../_shims/semantic-ui-react";
import RankingMapWrapper from "./RankingMapWrapper";
import ShareButtonWrapper from "./ShareButtonWrapper";
import InvisibleScrollTracker from "./InvisibleScrollTracker";

/**
 * Minimal client component for map column only
 * Manages visible items state from IntersectionObserver
 */
export default function MapColumnClient({
  initialData,
  cityName,
  stateName,
  selectedFilter,
  mapTitle,
  filterval,
  isMobile,
}) {
  const [visibleItems, setVisibleItems] = useState([]);

  return (
    <>
      {/* Invisible tracker - client component */}
      <InvisibleScrollTracker
        items={initialData}
        onVisibleItemsChange={setVisibleItems}
        isMobile={isMobile}
      />

      {/* Map column - client component */}
      <Grid.Column width={6} className="nh_map_section">
        <ShareButtonWrapper />
        <RankingMapWrapper
          cityName={cityName}
          stateName={stateName}
          selectedFilter={selectedFilter}
          mapTitle={mapTitle}
          filterval={filterval}
          initialData={initialData}
          visibleItems={visibleItems}
        />
      </Grid.Column>
    </>
  );
}
